import { Plus, ShoppingCart, X } from "lucide-react";
import type { POSSession } from "../hooks/usePOSCart";

interface POSSessionTabsProps {
  sessions: POSSession[];
  activeSessionId: string;
  setActiveSessionId: (id: string) => void;
  addSession: () => void;
  removeSession: (id: string, e?: React.MouseEvent) => void;
}

export function POSSessionTabs({
  sessions,
  activeSessionId,
  setActiveSessionId,
  addSession,
  removeSession,
}: POSSessionTabsProps) {
  return (
    <div className="scrollbar-hide z-20 flex h-11 shrink-0 items-center gap-1 overflow-x-auto border-b border-slate-200 bg-white px-3">
      {sessions.map((session) => {
        const isActive = activeSessionId === session.id;
        const itemCount = session.cart?.length || 0;

        return (
          <div
            key={session.id}
            className={`group flex h-full shrink-0 items-center border-b-2 transition ${
              isActive
                ? "border-teal-500 bg-teal-50/50"
                : "border-transparent hover:bg-slate-50"
            }`}
          >
            <button
              type="button"
              onClick={() => setActiveSessionId(session.id)}
              className={`flex h-full items-center gap-2 pl-3 text-xs font-semibold transition ${
                sessions.length > 1 ? "pr-1.5" : "pr-3"
              } ${isActive ? "text-teal-800" : "text-slate-600"}`}
            >
              <ShoppingCart
                className={`h-3.5 w-3.5 ${isActive ? "text-teal-600" : "text-slate-400"}`}
              />
              <span>{session.name}</span>
              {itemCount > 0 && (
                <span
                  className={`flex h-[19px] min-w-[19px] items-center justify-center rounded-full px-1 text-[9px] font-bold ${
                    isActive
                      ? "bg-teal-100 text-teal-700"
                      : "bg-slate-100 text-slate-600"
                  }`}
                >
                  {itemCount}
                </span>
              )}
            </button>

            {sessions.length > 1 && (
              <button
                type="button"
                aria-label={`Close ${session.name}`}
                onClick={(event) => {
                  event.stopPropagation();
                  removeSession(session.id, event);
                }}
                className="mr-1.5 flex h-6 w-6 items-center justify-center rounded-md text-slate-400 transition hover:bg-red-50 hover:text-red-500"
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </div>
        );
      })}

      <button
        type="button"
        onClick={addSession}
        className="ml-1 flex h-8 shrink-0 items-center gap-1.5 rounded-lg px-2.5 text-xs font-medium text-slate-500 transition hover:bg-teal-50 hover:text-teal-700"
      >
        <Plus className="h-3.5 w-3.5" />
        New cart
      </button>
    </div>
  );
}
